export var loopPromiseCaughtError = function loopPromiseCaughtError(originalActionType, error) {
  return "\nException thrown when running Cmds from action: ".concat(originalActionType, ".\n\nThrown exception: \n").concat(error, "\n");
};